import { parse, serialize, type CookieParseOptions, type CookieSerializeOptions } from 'cookie-es';

export function getCookie(key: string, options?: CookieParseOptions) {
  const value = parse(document.cookie, options)[key];
  try {
    return JSON.parse(decodeURIComponent(value));
  } catch (_error) {
    return value;
  }
}

export function setCookie(key: string, value: string | object, options?: CookieSerializeOptions) {
  const stringifiedValue = typeof value === 'string' ? value : JSON.stringify(value);
  document.cookie = serialize(key, stringifiedValue, {
    path: '/',
    maxAge: 365 * 24 * 60 * 60,
    expires: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000),
    ...options,
  });
}

export function removeCookie(key: string, options?: CookieSerializeOptions) {
  // 确保删除 cookie 时使用与设置时相同的路径和域名选项
  document.cookie = serialize(key, '', {
    path: '/',
    ...options,
    expires: new Date(0),
  });
}

// 缓存key映射
export enum COOKIE_KEY {
  USER_TOKEN = 'youyan-user-token',
  USER_RIGHTS = 'youyan-user-rights',
  LOCALE = 'i18n_redirected',
  TIMEZONE = 'x-timezone',
  USER_RANDOM_ID = 'youyan-user-random-id',
  COMPATIBILITY_HINT = 'compatibility-hint',
}
